import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { resources } from "translation/en";

import { Header } from "components/atoms/header/index";
import { AuthService } from "core/service/auth.service";
import { SignUpForm } from "components/molecules/signup-form/index";
import { SignInForm } from "components/molecules/signin-form/index";
import { FooterImages } from "./constants";

import * as S from "./signup.styles";

export const PartnerSignUp = () => {
  const { t } = useTranslation();
  const [affiliate, setAffiliate] = useState(false);

  useEffect(() => {
    const affiliate = AuthService.getAffiliateDetails();
    setAffiliate(affiliate);
  }, []);

  const list = resources.en.translation.signup.which.advantages;
  const which_list =
    resources.en.translation.signup.which.supported_income_types.types;
  const footer_list = resources.en.translation.signup.which.footer.advantages;

  const renderList = (list, list_name, content, color) =>
    Object.entries(list).map(([key]) => {
      const hint = `${list_name}.${key}`;
      if (content === "advantagelist") {
        return (
          <S.AdvantageList color={color} key={key}>
            {t(hint)}
          </S.AdvantageList>
        );
      } else {
        return (
          <S.IncomeTypesList color={color} key={key}>
            {t(hint)}
          </S.IncomeTypesList>
        );
      }
    });

  const renderFooter = () =>
    Object.entries(list).map(([key]) => {
      return (
        <S.FooterList key={key}>
          <img alt={key} src={FooterImages[key]}></img>
          <p>{t(`${footer_list[key]}`)}</p>
        </S.FooterList>
      );
    });

  return (
    <div>
      <Header company={affiliate} />
      <S.ContainerRight>
        <SignUpForm />
      </S.ContainerRight>
      <S.ContainerRight>
        <SignInForm />
      </S.ContainerRight>
      <S.ContainerRight>
        <h4>{t("signup.which.message")}</h4>
        <S.ContainerLeft>
          <S.Advantages>
            {renderList(
              list,
              "signup.which.advantages",
              "advantagelist",
              "#000"
            )}
          </S.Advantages>
        </S.ContainerLeft>
      </S.ContainerRight>
      <S.ContainerRight>
        <S.SupportedTypes>
          <S.SupportedTypesContainer>
            <h4>{t("signup.which.supported_income_types.header")}</h4>
            <S.Advantages>
              {renderList(
                which_list,
                "signup.which.supported_income_types.types",
                "incometypelist",
                "#e30613"
              )}
            </S.Advantages>
          </S.SupportedTypesContainer>
        </S.SupportedTypes>
      </S.ContainerRight>
      <S.Footer>{renderFooter()}</S.Footer>
    </div>
  );
};
